import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface HomePageData {
  data: any
  loading: boolean
  error: AppError | null
  initialized: boolean
}

const homePageRepository: any = RepositoryFactory.get('homePageRepository')

export const useHomepageStore = defineStore('homepage', {
  state: () =>
    <HomePageData>{
      data: StorageHelper.getItem('homepageData', []),
      loading: true,
      error: null,
      initialized: false
    },
  getters: {
    getHomepageData: (state) => state.data,
    getHomepageLoading: (state) => state.loading
  },
  actions: {
    async fetchAllHomepageComponents() {
      if (this.initialized) {
        return
      }

      this.loading = true
      try {
        const response = await homePageRepository.getAllHomePageComponents()
        this.data = response.data.fields
        StorageHelper.setItem('homepageData', this.data)
        this.initialized = true
      } catch (error) {
        this.initialized = true
        console.error('Error fetching:', error)
        this.error = {
          message: 'Problem with fetching menu'
        }
        throw error
      } finally {
        this.initialized = true
        this.loading = false
      }
    }
  }
})
